module.exports = {"menu":{"home":"Home","starship":"Starship","profile":"Profile","ranking":"Ranking","settings":"Settings"},"landing":{"spaceship-travel":"Teleport to your ship"},"profile":{"change-language":"Change language","change-language-en":"Change language to English","change-language-es":"Change language to Spanish","change-language-kr":"Change language to Korean"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = NuBg
// module chunks = 0